import AuthService from '../../../../services/auth-service';
import ClientService from '../../../../services/client-service';
import { LOGOUT_USER_SUCCESS } from '../../../../constants/system/actions';

const logoutReducer: Reducer = (
  state: ReducerState = {},
  action: ReduxAction,
): ReducerState => {
  switch (action.type) {
    case LOGOUT_USER_SUCCESS:
      AuthService.deleteAuthToken();
      ClientService.resetToken();
      ClientService.closeConnections();

      return state;
    default:
      return state;
  }
};

export default logoutReducer;
